export default function VideoFallback() {
    return (
        <>
            <div className="bg-red-500">
                Video ELement fallback
            </div>
        </>
    )
}
